import React from 'react';

/**
 * USA silhouette icon — used across the CC Network entry points so the
 * icon reads as "the shape of America" (per user request), not as a
 * generic map pin. Simplified lower-48 continental outline with a
 * small Alaska nub bottom-left and three Hawaii dots trailing right.
 * Fills to `currentColor` so it inherits the wrapping text color and
 * works on both light + dark backgrounds.
 */
const UsaMapIcon = ({ className = '', size, ...rest }) => {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      style={style}
      aria-hidden="true"
      {...rest}
    >
      {/* Lower-48 continental outline — hand-tuned to read at 18-24px */}
      <path
        d="M2.4 8.6 L3.6 8.1 L5.0 8.3 L6.4 7.7 L7.9 7.8 L9.6 7.3 L11.2 7.5
           L12.9 7.1 L14.6 7.2 L16.4 6.7 L18.1 7.0 L19.6 6.5 L21.4 6.9
           L21.9 8.0 L21.6 9.2 L21.0 10.4 L20.6 11.6 L20.9 12.8
           L20.4 14.0 L19.5 14.9 L18.3 15.5 L16.9 15.7 L15.3 16.0
           L13.9 16.5 L12.4 16.7 L11.0 16.9 L9.6 16.5 L8.2 16.7
           L7.0 16.3 L5.8 15.9 L4.7 15.3 L3.8 14.4 L3.2 13.3
           L2.9 12.1 L2.6 11.0 L2.3 9.8 Z"
      />
      {/* Florida stub */}
      <path d="M15.9 16.0 L16.6 17.5 L16.9 18.9 L16.4 19.3 L15.9 18.4 L15.6 17.1 Z" />
      {/* Alaska */}
      <path d="M2.4 19.2 L3.9 18.5 L5.1 19.0 L4.9 20.2 L3.6 20.6 L2.6 20.2 Z" />
      {/* Hawaii dots */}
      <circle cx="7.2" cy="19.9" r="0.55" />
      <circle cx="8.5" cy="20.1" r="0.55" />
      <circle cx="9.7" cy="20.3" r="0.55" />
    </svg>
  );
};

export default UsaMapIcon;
